import { formatSeconds } from './util';

class BarChart {
    constructor({ container = '', data = [], width = 1100, height = 100, moreWidth = 100, unit = 60, divideWork = [] }, callback1 = function() {}, callback2 = function() {}, callback3 = function() {}, callback4 = function() {}) {
        this.container = container;
        this.data = data;
        this.width = width;
        this.height = height;
        this.moreWidth = moreWidth;
        this.interval = unit;
        this.divideWork = divideWork;
        this.isExpand = false;
        //由排班时间表来确定该工厂开始时间
        if (divideWork.length != 0) {
            this.StartTime = divideWork[0].start;
        }
        this.rulerUnit = (this.width - this.moreWidth) / (86400 / this.interval); //最小细胞
        //把每个时间段的开始时间和结束时间算出来
        let currentTime = this.StartTime;
        this.data.forEach(item => {
            item.start = formatSeconds(currentTime);
            currentTime += item.number * this.interval;
            if (currentTime >= 86400) {
                currentTime -= 86400;
            }
            item.end = formatSeconds(currentTime);
        });
        /////////////////绘制///////////////
        //创建舞台
        this.stage = new Konva.Stage({
            container: this.container,
            width: this.width,
            height: this.height
        });
        let imgHeight = height - 75;
        //在后台画出一个图片
        let imageBaseUrl = this.getBaseUrl(imgHeight);
        //绘制标尺图层
        this.drawRule(imgHeight);
        //创建图片图层 把图片加到stage中 、宽，高，url，数据，分班，显示tooltip，隐藏，鼠标移动时候处理的功能
        this.drawChart(imgHeight, imageBaseUrl, callback1, callback2, callback3, callback4);
        this.animation(imgHeight);
    }
    //创建图条的函数
    drawChart(imgHeight, imgURl, callback1, callback2, callback3, callback4) {
        //图层
        let imgLayer = new Konva.Layer();
        this.stage.add(imgLayer);
        let imgGroup = new Konva.Group({
            x: this.moreWidth / 2,
            y: 0
        });
        imgLayer.add(imgGroup);
        imgGroup.on('mouseover touchstart', evt => {
            let x = 0;
            if (evt.type == 'mouseover') {
                document.body.style.cursor = 'pointer';
                x = evt.evt.layerX;
                callback1(x);
                getStatus(x);
            } else {
                if (evt.evt.touches.length == 1) {
                    x = evt.evt.touches[0].pageX - 16 - 2;
                    callback1(x);
                    getStatus(x);
                }
            }
        });
        imgGroup.on('mouseout touchend', evt => {
            // document.body.style.cursor = 'default';
            callback2(evt.evt.clientX, evt.evt.clientY);
        });
        imgGroup.on('mousemove touchmove', evt => {
            let x = 0;
            if (evt.type == 'mousemove') {
                x = evt.evt.layerX;
                getStatus(x);
            } else {
                if (evt.evt.touches.length == 1) {
                    x = evt.evt.touches[0].pageX - 16;
                    getStatus(x);
                }
            }
        });
        let getStatus = x => {
            //时间
            let time = Math.round(((x - this.moreWidth / 2) * this.interval) / this.rulerUnit) + this.StartTime;
            time = time <= 86400 ? time : time - 86400; // 秒
            //状态 持续时间
            let status = 5; //默认未开始
            let range = ''; //持续时间范围
            let number = (x - this.moreWidth / 2) / this.rulerUnit;
            for (let item of this.data) {
                if (number < item.number) {
                    status = item.status;
                    let start = item.start.split(':'),
                        end = item.end.split(':');
                    start.pop();
                    end.pop();
                    start = start.join(':');
                    end = end.join(':');
                    let r = formatSeconds(item.number * this.interval).split(':');
                    r = `${Number(r[0])}h${Number(r[1])}m`;
                    range = `${start}-${end}(${r})`;
                    break;
                } else {
                    number = number - item.number;
                }
            }
            callback3(x, formatSeconds(time), range, status);
        };
        imgGroup.on('dblclick', evt => {
            let x = evt.evt.layerX;
            this.isExpand = !this.isExpand;
            callback4(x, this.isExpand);
        });
        imgGroup.on('wheel', evt => {});

        let imageObj = new Image();
        imageObj.onload = () => {
            let chartImg = new Konva.Image({
                x: 0,
                y: 0,
                image: imageObj,
                width: this.width - this.moreWidth, //图条的宽度
                height: imgHeight
            });
            imgGroup.add(chartImg);
            imgLayer.draw();
        };
        imageObj.src = imgURl;
    }
    //创建尺子的函数
    drawRule(imgHeight) {
        let layer = new Konva.Layer();
        this.stage.add(layer);
        //横线组
        let lineGroup = new Konva.Group({
            x: this.moreWidth / 2,
            y: imgHeight + 10
        });
        layer.add(lineGroup);
        let line = new Konva.Line({
            points: [0, 0 + 0.5, this.width - this.moreWidth, 0 + 0.5], //加0.5解决1像素模糊的问题
            stroke: '#5E5E5E',
            strokeWidth: 1
        });
        lineGroup.add(line);
        //尺寸组
        let ruleGroup = new Konva.Group({
            x: this.moreWidth / 2,
            y: imgHeight + 10
        });
        layer.add(ruleGroup);

        let timeCall = 3600; //两条竖线之间表示多长时间
        let allTime = 24;

        let UnitCall = (timeCall / this.interval) * this.rulerUnit;
        let locationX = 0;
        let createTime = 0; //创建竖线的次数
        do {
            let uLine = new Konva.Line({
                points: [locationX + 0.5, 0, locationX + 0.5, 12],
                stroke: '#5E5E5E',
                strokeWidth: 1
            });
            ruleGroup.add(uLine);
            if (createTime % 6 == 0) {
                let time = Math.round((locationX * this.interval) / this.rulerUnit) + this.StartTime;
                time = time <= 86400 ? time : time - 86400; // 秒
                let text = new Konva.Text({
                    x: locationX,
                    y: 15,
                    text: formatSeconds(time),
                    fill: '#111'
                });
                if (createTime == allTime) {
                    text.setOffset({
                        x: text.getWidth()
                    });
                } else if (createTime != 0) {
                    text.setOffset({
                        x: text.getWidth() / 2
                    });
                }
                ruleGroup.add(text);
            }
            createTime++;
            locationX += UnitCall;
        } while (createTime <= allTime);
        layer.draw();
        //画分工图
        let slayer = new Konva.Layer();
        this.stage.add(slayer);

        this.divideWork.forEach(item => {
            this.brace(layer, slayer, this.moreWidth / 2, imgHeight + 35, item);
        });
    }
    //画大括号  name start end
    brace(textlayer, slayer, x, y, obj) {
        let start = obj.start >= this.StartTime ? obj.start - this.StartTime : obj.start + 86400 - this.StartTime;
        let end = obj.end >= this.StartTime ? obj.end - this.StartTime : obj.end + 86400 - this.StartTime;
        let startPx = (start * this.rulerUnit) / this.interval;
        let endPx = (end * this.rulerUnit) / this.interval;
        let midPx = (startPx + endPx) / 2;
        let dy = 25;

        //开始画
        let ctx = slayer.getContext();

        ctx.beginPath();
        ctx.moveTo(x + startPx, y);
        ctx.bezierCurveTo(x + startPx, y + dy, x + midPx, y, x + midPx, y + dy);
        ctx.setAttr('strokeStyle', '#111');
        ctx.setAttr('lineWidth', 1);
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(x + endPx, y);
        ctx.bezierCurveTo(x + endPx, y + dy, x + midPx, y, x + midPx, y + dy);
        ctx.setAttr('strokeStyle', '#111');
        ctx.setAttr('lineWidth', 1);
        ctx.stroke();

        let text = new Konva.Text({
            x: x + midPx,
            y: y + dy,
            text: obj.name,
            fill: '#111'
        });
        text.setOffset({
            x: text.getWidth() / 2
        });
        textlayer.add(text);
        textlayer.draw();
    }
    //获得图条的图片
    getBaseUrl(imgHeight) {
        //创建图条层
        let layer = new Konva.Layer();
        this.stage.add(layer);
        let group = new Konva.Group({
            x: 0,
            y: 0,
            width: this.width - this.moreWidth,
            height: imgHeight
        });
        layer.add(group);
        //开始画
        let color = ['#898989', '#009900', '#C6C013', '#EF2917', '#eeeeee', '#fff']; //绘制的颜色  停止，运行，待机，报警,离线 未工作
        //画数据
        let locationX = 0;
        for (let item of this.data) {
            let width = item.number * this.rulerUnit;
            let rect = new Konva.Rect({
                x: locationX,
                y: 0,
                width: width,
                height: imgHeight,
                fill: color[item.status]
            });
            group.add(rect);
            // 设置下一个元素具体的位置
            locationX += width;
        }
        layer.draw();
        let url = group.toDataURL();
        layer.remove();
        return url;
    }
    //动画加载
    animation(imgHeight) {
        var coverLayer = new Konva.Layer();
        this.stage.add(coverLayer);
        var coverRect = new Konva.Rect({
            x: this.moreWidth / 2,
            y: 0,
            width: this.width - this.moreWidth,
            height: imgHeight,
            fill: '#fff'
        });
        coverLayer.add(coverRect);
        coverLayer.draw();
        coverLayer.to({
            x: this.width - this.moreWidth,
            duration: 2,
            onFinish: () => {
                coverLayer.remove();
            }
        });
        coverRect.to({
            width: 0,
            duration: 2
        });
    }
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/libs/barChart.js